import React, { useState, useEffect } from "react";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { cardsAPI } from "../../services/api";
import "./Admin.css";

const STATUS_LABELS = {
  pending: "Pendiente",
  approved: "Aprobada",
  rejected: "Rechazada",
  submitted: "Enviada",
  cancelled: "Cancelada",
};

const STATUS_COLORS = {
  pending: "#f39c12",
  approved: "#2ecc71",
  rejected: "#e74c3c",
  submitted: "#3498db",
  cancelled: "#95a5a6",
};

const Cards = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [statusFilter, setStatusFilter] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    fetchCards();
  }, [statusFilter, page]);

  const fetchCards = async () => {
    try {
      setLoading(true);
      const res = await cardsAPI.getCards({ status: statusFilter, page, limit: 20 });
      setCards(res.data.cards);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching cards:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (cardId, newStatus) => {
    try {
      await cardsAPI.updateCard(cardId, { status: newStatus });
      fetchCards();
    } catch (error) {
      console.error("Error updating card:", error);
    }
  };

  const handleDelete = async (cardId) => {
    if (window.confirm("¿Está seguro de eliminar esta tarjeta?")) {
      try {
        await cardsAPI.deleteCard(cardId);
        fetchCards();
      } catch (error) {
        console.error("Error deleting card:", error);
      }
    }
  };

  return (
    <DashboardLayout title="Gestión de Tarjetas">
      {/* Filters */}
      <div className="filters-bar">
        <select value={statusFilter} onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}>
          <option value="">Todos los estados</option>
          {Object.entries(STATUS_LABELS).map(([key, label]) => (
            <option key={key} value={key}>{label}</option>
          ))}
        </select>
        <span className="results-count">{cards.length} resultados</span>
      </div>

      {loading ? (
        <div className="loading">Cargando...</div>
      ) : (
        <>
          <div className="data-table-container">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Nombre</th>
                  <th>Email</th>
                  <th>Teléfono</th>
                  <th>Tipo</th>
                  <th>Banco</th>
                  <th>Ingreso Anual</th>
                  <th>Estado</th>
                  <th>Fecha</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {cards.length === 0 ? (
                  <tr><td colSpan="9" className="empty-row">No hay tarjetas registradas</td></tr>
                ) : (
                  cards.map((card) => (
                    <tr key={card._id}>
                      <td>{card.firstName} {card.lastName}</td>
                      <td>{card.email}</td>
                      <td>{card.phone}</td>
                      <td>{card.cardType}</td>
                      <td>{card.bank}</td>
                      <td>${card.annualIncome?.toLocaleString()}</td>
                      <td>
                        <span
                          className="status-badge"
                          style={{ backgroundColor: STATUS_COLORS[card.status] }}
                        >
                          {STATUS_LABELS[card.status]}
                        </span>
                      </td>
                      <td>{new Date(card.createdAt).toLocaleDateString()}</td>
                      <td className="actions-cell">
                        <select
                          value={card.status}
                          onChange={(e) => handleStatusChange(card._id, e.target.value)}
                          className="action-select"
                        >
                          {Object.entries(STATUS_LABELS).map(([key, label]) => (
                            <option key={key} value={key}>{label}</option>
                          ))}
                        </select>
                        <button onClick={() => handleDelete(card._id)} className="btn-danger-sm">
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)}>Anterior</button>
              <span>Página {page} de {totalPages}</span>
              <button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Siguiente</button>
            </div>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default Cards;
